import { RateFlowDetails } from "../../../../../../types"

type Props = {
  info: RateFlowDetails
}

const StatusCell = ({ info }: Props) => {
  const isActive = info.active !== "0"

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 text-right md:text-left">
      {isActive ? (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700">
          Active
        </span>
      ) : (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700">
          Inactive
        </span>
      )}
    </td>
  )
}

export default StatusCell
